import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { useSortLoading } from '@op/models/commonLoading/useSortLoading';
import { getWeeklyVersionStat } from '@op/services';
import { useEffect, useState } from 'react';
import { SortLoadingKeysType } from '../type';

export default function useVersionCardData({ filter }: { filter: any }) {
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    defaultLoading: true,
  });
  const { finishLoading } = useSortLoading<SortLoadingKeysType>();
  const [cardData, setCardData] = useState();

  function getWeeklyVersionCard() { 
    wrapperCancelRequest(getWeeklyVersionStat, filter)
      .then(data => {
        setCardData(data);
      })
      .catch(() => {})
      .finally(() => {
        finishLoading('metric', filter.module_id);
      });
  }

  useEffect(() => {
    if (filter) {
      getWeeklyVersionCard();
    }
  }, [filter]);

  return { loading, cardData };
}
